import { InboxNotiDto } from '@diritto/common/notification/dtos/inbox-noti.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import { convertToDotString, convertToRelativeString } from '@diritto/common/utils/date';
import styled from '@emotion/styled';
import { CopyIcon } from 'icons/CopyIcon';
import { DirittoCircleIcon } from 'icons/DirittoCircleIcon';
import * as Styled from 'app-components/inbox/items/styles';
import React, { useCallback, useState } from 'react';
import { getTextLineStyle } from 'styles/common';
import { Divider } from 'ui-components/common/Divider';
import { useCopyText } from 'ui-hooks/useCopyText';
import { showToast } from 'utils/modal';

interface RidiPointCouponInboxNotiListItemProps {
  inboxNoti: InboxNotiDto;
  ridiPointCouponCode: string;
}

export const RidiPointCouponInboxNotiListItem = ({
  inboxNoti,
  ridiPointCouponCode,
}: RidiPointCouponInboxNotiListItemProps) => {
  const [isRead] = useState(inboxNoti.isRead);

  const copyText = useCopyText();
  const handleCopyClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      try {
        await copyText(ridiPointCouponCode);
        showToast('쿠폰 번호가 복사되었어요.', {
          externalLink: { text: '등록하러 리디 가기 >', url: 'https://ridibooks.com/coupon/' },
        });
      } catch {
        showToast('쿠폰 번호 복사에 실패했어요.');
      }
    },
    [copyText, ridiPointCouponCode],
  );

  return (
    <Styled.Container>
      <Styled.LeftIconSection>
        <Styled.Unread isRead={isRead} />
        <DirittoCircleIcon className="size-[56px]" />
      </Styled.LeftIconSection>
      <Styled.RightSection>
        <Styled.TitleWrapper>
          <Styled.SanitizeHTMLTitle
            html={`${inboxNoti.title}<span class="inbox-title-date" title="${convertToDotString(
              inboxNoti.sentAt,
            )}">${convertToRelativeString(inboxNoti.sentAt)}</span>`}
            options={{
              allowedTags: ['b', 'span', 'br'],
              allowedClasses: {
                span: ['inbox-title-date'],
              },
              allowedAttributes: { span: ['title'] },
            }}
          />
        </Styled.TitleWrapper>
        <Styled.Extra>
          <StyledD>
            <StyledCouponCode>{ridiPointCouponCode}</StyledCouponCode>
            <StyledCouponCodeButton onClick={handleCopyClick}>
              <CopyIcon color={Color.Primary500} />
              <StyledSpan>복사하기</StyledSpan>
            </StyledCouponCodeButton>
          </StyledD>
        </Styled.Extra>
      </Styled.RightSection>
      <Divider color={Color.Gray200} />
    </Styled.Container>
  );
};

const StyledD = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledCouponCode = styled.p`
  margin-right: 6px;
  ${Typography.XXSmall}
  ${getTextLineStyle(3)};
  color: ${Color.Gray600};
`;

const StyledCouponCodeButton = styled.button`
  ${Typography.XXSmall}
  color: ${Color.Primary500};
  align-items: center;
  display: flex;
`;

const StyledSpan = styled.span`
  margin-left: 4px;
`;
